
interface AccountingJournalTemplateEntryAddCellDelegate
{
    addLineDidPress(cell:AccountingJournalTemplateEntryAddCell, group:AccountingJournalGroupTemplate, keyFormat:string, account:LedgerAccount, valueFormula:string, entrySide:number):void;
}

class AccountingJournalTemplateEntryAddCell extends UITableViewCell
{
    delegate:AccountingJournalTemplateEntryAddCellDelegate|null = null;

    // Key format options per matchMode (same as EntryCell)
    private static keyOptionsByMatchMode: { [key: number]: string[][] } = {
        0: [["supplierLedgerAccount", "SUPPLIER_LEDGER_ACCOUNT"], ["customLedgerAccount", "CUSTOM_LEDGER_ACCOUNT"]],
        1: [["productLineLedgerAccount", "PRODUCT_LINE_LEDGER_ACCOUNT"], ["customLedgerAccount", "CUSTOM_LEDGER_ACCOUNT"]]
    };

    private addButton:MUIButton = null;
    private keyFormatComboBox:MUIComboBox = null;
    private accountDropdown:MUIButton = null;
    private formulaTextField:MUITextField = null;
    private sideSegmented:MUISegmentedControl = null;

    private _selectedAccount:LedgerAccount|null = null;
    private _selectedKeyFormat:string|null = null;
    private _entrySide:number = 0; // 0 = debit
    private _group:AccountingJournalGroupTemplate|null = null;
    private _keyOptions:string[][] = [];

    awakeFromHTML()
    {
        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        if (this.addButton) this.addButton.setAction(this, function(this:AccountingJournalTemplateEntryAddCell){
            this.addButtonDidPress();
        });

        this.keyFormatComboBox = MUIOutlet(this, "key-format-cb", "MUIComboBox");
        if (this.keyFormatComboBox) this.keyFormatComboBox.setOnChangeAction(this, function(this:AccountingJournalTemplateEntryAddCell, control:MUIComboBox, value:string){
            let index = parseInt(value);
            this._selectedKeyFormat = (index >= 0 && this._keyOptions[index] != null) ? this._keyOptions[index][0] : null;
            this.updateAccountDropdownEnabled(this._selectedKeyFormat);
            if (this._selectedKeyFormat != "customLedgerAccount") {
                this._selectedAccount = null;
                if (this.accountDropdown) this.accountDropdown.title = MIOLocalizeString("SELECT_LEDGER_ACCOUNT", "SELECT LEDGER ACCOUNT");
            }
        });

        this.accountDropdown = MUIOutlet(this, "account-dd", "MUIButton");
        if (this.accountDropdown) this.accountDropdown.setAction(this, function(){
            if (this._selectedKeyFormat != "customLedgerAccount") return;
            this.showSelectLedgerAccount(null, false);
        });

        this.formulaTextField = MUIOutlet(this, "value-formula-tf", "MUITextField");

        this.sideSegmented = MUIOutlet(this, "side-segmented", "MUISegmentedControl");
        if (this.sideSegmented) this.sideSegmented.setAction(this, function(this:AccountingJournalTemplateEntryAddCell, control, index){
            this._entrySide = index;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set group(group:AccountingJournalGroupTemplate|null) {
        this._group = group;
        let matchMode = group?.matchMode ?? 0;
        this._keyOptions = AccountingJournalTemplateEntryAddCell.keyOptionsByMatchMode[matchMode] ?? [];
        this.populateKeyOptions();
    }

    get group():AccountingJournalGroupTemplate|null { return this._group; }

    private populateKeyOptions() {
        if (this.keyFormatComboBox == null) return;
        this.keyFormatComboBox.removeAllItems();
        this.keyFormatComboBox.addItem(MIOLocalizeString("SELECT", "SELECT"), -1);
        for (let i = 0; i < this._keyOptions.length; i++) {
            this.keyFormatComboBox.addItem(MIOLocalizeString(this._keyOptions[i][1], this._keyOptions[i][1]), i);
        }
        this.keyFormatComboBox.selectItem(-1);
        this._selectedKeyFormat = null;
        this.updateAccountDropdownEnabled(null);
    }

    private updateAccountDropdownEnabled(key:string) {
        let enabled = key == "customLedgerAccount";
        if (this.accountDropdown) this.accountDropdown.setEnabled(enabled);
    }

    private showSelectLedgerAccount(searchString:string, hideSearchBar:boolean){
        AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.accountDropdown, this._selectedAccount, searchString, hideSearchBar, null, this, this.updateLedgerAccount);
    }

    private updateLedgerAccount(controller, account:LedgerAccount){
        this._selectedAccount = account;
        if (this.accountDropdown) this.accountDropdown.title = account?.name;
    }

    private addButtonDidPress(){
        if (this._selectedKeyFormat == null) return;
        let formula = this.formulaTextField ? this.formulaTextField.text : "";
        if (this.delegate) this.delegate.addLineDidPress(this, this._group, this._selectedKeyFormat, this._selectedAccount, formula, this._entrySide);
        this.reset();
    }

    private reset(){
        this._selectedAccount = null;
        this._selectedKeyFormat = null;
        this._entrySide = 0;
        if (this.keyFormatComboBox) this.keyFormatComboBox.selectItem(-1);
        if (this.accountDropdown) {
            this.accountDropdown.title = MIOLocalizeString("SELECT_LEDGER_ACCOUNT", "SELECT LEDGER ACCOUNT");
            this.accountDropdown.setEnabled(false);
        }
        if (this.formulaTextField) this.formulaTextField.text = null;
        if (this.sideSegmented) this.sideSegmented.selectedSegmentedIndex = 0;
    }
}
